import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Outlet } from 'react-router';

export default function AdminOrClubesRoute() {
  const { isAdmin, isClubes } = useAuth();
  return isAdmin() || isClubes() ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
